import React, {Component} from 'react';
import { Col, Row,Button, FormControl} from 'react-bootstrap';
import Datetime from 'react-datetime'
import moment from 'moment'
 import Select   from 'react-select'
 import {
    ADD_SELECTED_SELLERS,CLEAR_SELECTED_SELLERS
} from "actions/actionTypes";
import config from  '../../../config';

export default class AdminSellerSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        var selectedMarkets = _.isUndefined(this.props.location.query.Markets) ? [] : _.map(this.props.location.query.Markets.split(','), function (item) {
            var location = _.find(config.warehouseData, function (o) {
                return o.MarketName == item
            });
            if (location) {
                return {'value': item, 'label': location.MarketName}
            }
        })
        this.state = {
             filterOptions: {
                 SellerNumber: _.isUndefined(this.props.location.query.SellerNumber) ? '' : this.props.location.query.SellerNumber,
                 perPage: _.isUndefined(this.props.location.query.perPage) ? config.table.numberPerPage : this.props.location.query.perPage,
                 searchText: _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,
                fromCreateTimeDisplay:'', // _.isUndefined(this.props.location.query.from) ? '' : moment(this.props.location.query.from),
              toCreateTimeDisplay:'', // _.isUndefined(this.props.location.query.to) ? '' : moment(this.props.location.query.to),
                 Markets:selectedMarkets
             }
        };

    };
    onCreateTimeChange(option, createTimeOptionName) {

        var optionDisplay = '';
        if (option !== '') {
            optionDisplay = option.format("MM-DD-YYYY");
          //  option = option.utc().format();

        }
        var isSameDate =  moment(this.state.filterOptions[createTimeOptionName]).isSame(option, 'day')
        var updateOptions = {...this.state.filterOptions, [createTimeOptionName]: option, createTime: option};
        this.setState({'filterOptions': updateOptions}, function () {
            if (!isSameDate) {
                this.props.search();
            }
        });
    }
    onMarketsSelect(options) {
        var updateOptions = {...this.state.filterOptions, Markets: options};
        this.setState({'filterOptions': updateOptions}, function () {
            this.props.search();
        });
    }
    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.search();
        }
    }

    getSearchParams(filtersChanged = {} ) {

        var filterOptions = {...this.state.filterOptions, ...filtersChanged};
        console.log('in search products',filterOptions );

      var  queryParams = {};

        if (filterOptions.searchText !== '') {
            queryParams.searchText = filterOptions.searchText;
        }
        if (filterOptions.fromCreateTimeDisplay !== '') {
             queryParams.from = filterOptions.fromCreateTimeDisplay.toISOString()
        }
        if (filterOptions.SellerNumber !== '') {
            queryParams.SellerNumber = filterOptions.SellerNumber;
        }
        if (filterOptions.toCreateTimeDisplay !== '') {
            queryParams.to = filterOptions.toCreateTimeDisplay.toISOString()
        }
        if (filterOptions.perPage == 'all') {
            queryParams.all = true
        } else {
            queryParams.perPage = filterOptions.perPage;
        }
        if (_.size(filterOptions.Markets) > 0) {
            queryParams.Markets = _.map(filterOptions.Markets, 'value').join(',')
        }
      return {queryParams}
    }
    onChangePerPageNumber(option) {
        this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}}, function () {
            this.props.search();
        });
    }
    onsearchTextChange(event) {
        var updateOptions = {...this.state.filterOptions, searchText: event.target.value};
        this.setState({'filterOptions': updateOptions});
    }
    onSellerNumberChange(event) {
        var updateOptions = {...this.state.filterOptions, SellerNumber: event.target.value};
        this.setState({'filterOptions': updateOptions});
    }
    onSelectAllRecordsChange() {
         var self = this;
        if (!this.props.selectAllRecords) {

            this.props.search( {include: ['_id'], all: true}).then(response => {
                this.props.toggleAllRecordsSelection(true)
                console.log('recordIds', response.data);

                self.props.dispatchAction(response.data.data, ADD_SELECTED_SELLERS)
            });
        } else {
            this.props.toggleAllRecordsSelection(false);

            this.props.dispatchAction({}, CLEAR_SELECTED_SELLERS)
        }
    }
    render() {
        var self = this;

console.log('this seller searchbox state', this.state );
         return (
            <div className="seller-search-block bot15">
                <Row className="">
                    <Col md={3} xs={3} className="top10">
                        <Button className="btn btn-primary" onClick = {this.onSelectAllRecordsChange.bind(this)} >
                            {this.props.selectAllRecords ? 'Clear selection' : 'Select all' }
                        </Button>
                    </Col>
                    <Col md={3} xs={3} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Per Page"
                            clearable={false}
                            options={config.perPageSelectOptions}
                            onChange={this.onChangePerPageNumber.bind(this)}
                            value={self.state.filterOptions.perPage}
                        />
                    </Col>
                </Row>
                <Row className="show-grid">

                    <Col md={3} xs={3} className="top10">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.searchText}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                      onChange={this.onsearchTextChange.bind(this)}
                                     placeholder="Search text"/>
                    </Col>
                    <Col md={3} xs={3} className="top10">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.SellerNumber}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                     onChange={this.onSellerNumberChange.bind(this)}
                                     placeholder="Seller Number"/>
                    </Col>
                    <Col xs={3} className="top10 pleft0">
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                  onChange={(value) =>this.onCreateTimeChange(value,  'fromCreateTimeDisplay')}
                                  value={this.state.filterOptions.fromCreateTimeDisplay}
                                  inputProps={{placeholder: 'From'}}/>
                    </Col>
                    <Col xs={3} className="top10 pleft0">
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                  onChange={(value) =>this.onCreateTimeChange(value,  'toCreateTimeDisplay')}
                                  value={this.state.filterOptions.toCreateTimeDisplay}
                                  inputProps={{placeholder: 'To'}}/>
                    </Col>
                    <Col xs={3} md={3} className="top10">
                        <Select
                            tabIndex="0"
                            multi
                            clearable={false}
                            placeholder="Location"
                            options={   _.map(config.warehouseData, item => {
                                return {value: item.MarketName, label: item.MarketName}
                            })}
                            onChange={this.onMarketsSelect.bind(this)}
                            value={self.state.filterOptions.Markets}
                        />
                    </Col>
                    <Col md={3} xs={6} className="top10">
                        <button className="btn btn-primary" disabled={this.props.pending} onClick={(event) => self.props.search({ })}
                                type="button">
                            Search
                        </button>
                    </Col>
                </Row>
            </div>
        );
    }
}



